import { api } from '../api';
import {
  CheckoutGuildOffersRequestParams,
  CheckoutRegularOffersRequestParams,
  FiatOffersResponse,
  GuildOffersResponse,
  OffersResponse,
} from './type';

export const WebshopApi = {
  getRegularOffers: async () => {
    const { data } = await api.get<OffersResponse>('/webshop/offers?offer_type=power');

    return data;
  },
  getFiatOffers: async (country: string) => {
    const { data } = await api.get<FiatOffersResponse>(`/webshop/offers?offer_type=fiat&country=${country}`);

    return data;
  },
  getGuildFiatOffers: async (country: string) => {
    const { data } = await api.get<GuildOffersResponse>(`/guild/offers?offer_type=fiat&country=${country}`);

    return data;
  },
  getGuildOffers: async () => {
    const { data } = await api.get<GuildOffersResponse>('/guild/offers?offer_type=power');

    return data;
  },
  checkoutRegularOffers: async (params: CheckoutRegularOffersRequestParams) => {
    const { data } = await api.post('/webshop/checkout', params);

    return data;
  },
  checkoutGuildOffers: async (params: CheckoutGuildOffersRequestParams) => {
    const { data } = await api.post('/guild/checkout', params);

    return data;
  },
};
